import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
  link: {
    color: 'inherit',
  },
  select: {
    paddingRight: 0,
  },
  selectMenu: {
    fontSize: '0.80rem',
  },
  speed: {
    marginRight: 5,
  }
}))

function MainHeader({ date, isPaused, onSpeedChange, onPause, output, speed }) {
  const classes = useStyles();
  return (
    <Grid container alignItems="center">
      <Grid item>
        <Typography variant="caption">{date} - </Typography>
        <Typography variant="caption">
          <a className={classes.link} href={output} rel="noopener noreferrer" target="_blank">
            Output
          </a>
        </Typography>
      </Grid>
      <Grid container item xs alignItems="baseline" justify="flex-end">
        <Grid item>
          <Typography className={classes.speed} variant="caption">Speed:</Typography>
          <Select
            disableUnderline
            value={speed}
            onChange={event => onSpeedChange(event.target.value)}
            classes={{
              select: classes.select,
              selectMenu: classes.selectMenu,
              icon: classes.icon
            }}
          >
            <MenuItem value={2}>2s</MenuItem>
            <MenuItem value={5}>5s</MenuItem>
            <MenuItem value={10}>10s</MenuItem>
            <MenuItem value={30}>30s</MenuItem>
            <MenuItem value={60}>1m</MenuItem>
          </Select>
        </Grid>
        <Grid item>
          <IconButton aria-label={isPaused ? "Resume" : "Pause"} onClick={onPause} size="small">
            { isPaused ? <PlayCircleOutlineIcon /> : <PauseCircleOutlineIcon />}
          </IconButton>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default MainHeader;
